/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, toRefs, inject, computed } from '@vue/composition-api';
import props from './option-group-props.js';
import { useTNodeJSX } from '../hooks/tnode.js';
import { usePrefixClass, useConfig } from '../config-provider/useConfig.js';
import useCommonClassName from '../hooks/useCommonClassName.js';
import 'lodash/isEmpty';
import 'lodash/isFunction';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../hooks/render-tnode.js';
import 'lodash/isString';
import 'lodash/isObject';
import '../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../_chunks/dep-9849f16c.js';
import '../config-provider/type.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _OptionGroup = defineComponent({
  name: "TOptionGroup",
  props: _objectSpread({}, props),
  setup: function setup(props2) {
    var _toRefs = toRefs(props2),
      divider = _toRefs.divider;
    var tSelect = inject("tSelect");
    var _useCommonClassName = useCommonClassName(),
      sizeClassNames = _useCommonClassName.sizeClassNames;
    var COMPONENT_NAME = usePrefixClass("select");
    var _useConfig = useConfig("classPrefix"),
      classPrefix = _useConfig.classPrefix;
    var classes = computed(function () {
      var _ref;
      return ["".concat(COMPONENT_NAME.value, "-option-group"), (_ref = {}, _defineProperty(_ref, sizeClassNames[tSelect.size], tSelect && tSelect.size), _defineProperty(_ref, "".concat(COMPONENT_NAME.value, "-option-group__divider"), divider), _ref)];
    });
    return {
      classes: classes,
      classPrefix: classPrefix,
      componentName: COMPONENT_NAME
    };
  },
  render: function render() {
    var h = arguments[0];
    var renderTNode = useTNodeJSX();
    var children = renderTNode("default");
    return h("li", {
      "class": this.classes
    }, [h("div", {
      "class": "".concat(this.componentName, "-option-group__header")
    }, [this.label]), children]);
  }
});

export { _OptionGroup as default };
//# sourceMappingURL=optionGroup.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/select/optionGroup.js
// module id = null
// module chunks = 